/**
 * Elemente beim hover neigen
 *
 * Das Tilt Script neigt einen bestimmten Selector beim hover mit der Maus.
 *
 * @param {string} selector - jQuery Selector für den Tilt Container
 * @param {string} tiltConfigName - Vordefinierte Tilt Config einstellungen
 *
 * Folgende Configs sind vorhanden:
 * primary__style: Standart neigen
 * glare__style: Funkeln/Glanz beim neigen
 * scale__style: Vergrößern beim neigen
 * glare_scale__style: Funkeln/Glanz und Vergrößern beim neigen
 *
 * @see https://gijsroge.github.io/tilt.js/
 *
 * Events: document.ready
 *
 * @return false
 */

var tiltConfig = {
    primary: {},
    glare: {perspective: 1500, glare: true, maxGlare: 0.5},
    scale: {scale: 1.2},
    glare_scale: {glare: true, maxGlare: 0.5, scale: 1.2},
};

function nc_initTilt(selector, tiltConfigName) {
    var moduleLogger = LoggerManager.get('tilt').setPrefix('Selektor: ' + selector + '; tiltConfigName: ' + tiltConfigName);
    moduleLogger.trace('INIT START');


    // Script bei Document Ready starten
    $(document).ready(function () {
        // Prüfen ob tiltConfigName übergeben und vorhanden ist
        if (typeof tiltConfig !== 'object' || typeof tiltConfig[tiltConfigName] === 'undefined') {
            // Fehlermeldung ausgeben
            moduleLogger.error('Übergebener tiltConfigName ungültig', tiltConfig);
            return false;
        }

        $(selector).tilt(
            tiltConfig[tiltConfigName]
        );
    });
    moduleLogger.info('INIT ENDE');
}

